import {
  GET_LIVE_STREAM_DATA_REQUEST,
  GET_LIVE_STREAM_DATA_SUCCESS,
  GET_LIVE_STREAM_DATA_FAILURE,
  AUTHENTICATE_LIVE_STREAM_REQUEST,
  AUTHENTICATE_LIVE_STREAM_SUCCESS,
  AUTHENTICATE_LIVE_STREAM_FAILURE,
  AUTHENTICATE_PERFORM_LIVE_STREAM,
  GET_LIVE_STREAM_TABS_REQUEST,
  GET_LIVE_STREAM_TABS_SUCCESS,
  GET_LIVE_STREAM_TABS_FAILURE,
  GET_LIVE_STREAM_COUPONS_DATA_REQUEST,
  GET_LIVE_STREAM_COUPONS_DATA_SUCCESS,
  GET_LIVE_STREAM_COUPONS_DATA_FAILURE,
  RESET_LIVE_STREAM_AUTHENTICATE,
  SET_LIVE_STREAM_START,
  SET_LIVE_STREAM_STOP,
  SET_TJK_LIVE_STREAM_START,
  SET_TJK_LIVE_STREAM_STOP
} from 'Store/constants';

const initialState = {
  tabs: {
    data: [],
    isLoading: true,
    error: null
  },
  streamData: {
    data: {},
    isLoading: true,
    error: null
  },
  activeStreamInfo: {
    url: null,
    streamId: null,
    provider: null,
    isPlaying: false,
    error: null
  },
  performInfo: {
    streamId: null,
    user: null,
    performAuthenticationToken: null,
    isHighlights: null,
    fixtureId: null,
  },
  couponData: {
    data: {},
    isLoading: false,
    error: null,
  },

  liveStreamStartTime: null,
  tjkLiveStreamStartTime: null,
  multipleLmtStreamInfo: {},
  hasRun: false
};

export default (state = initialState, action) => {
  switch (action.type) {
    case AUTHENTICATE_LIVE_STREAM_REQUEST:
      return {
        ...state,
        activeStreamInfo: {
          url: null,
          provider: null,
          isLoading: true,
          error: null
        }
      };

    case AUTHENTICATE_LIVE_STREAM_SUCCESS:
      if (action.payload?.performInfo?.isHighlights) {
        return {
          ...state,
          activeStreamInfo: {
            url: action.payload.url,
            provider: action.payload.provider,
            statusCode: action.payload.code,
            description: action.payload.description,
            streamId: action.payload?.streamId,
            isLoading: false,
            error: null
          },
          multipleLmtStreamInfo: {
            ...state.multipleLmtStreamInfo,
            [action.payload.streamId]: action.payload,
          },
        };
      } else {
        return {
          ...state,
          activeStreamInfo: {
            url: action.payload.url,
            provider: action.payload.provider,
            statusCode: action.payload.code,
            description: action.payload.description,
            streamId: action.payload?.streamId,
            isLoading: false,
            error: null
          },
          performInfo: {
            streamId: null,
            user: null,
            performAuthenticationToken: null,
            isHighlights: null,
            fixtureId: null,
          },
          multipleLmtStreamInfo: {
            ...state.multipleLmtStreamInfo,
            [action.payload.streamId]: action.payload,
          },
        };
      }
     
    case AUTHENTICATE_LIVE_STREAM_FAILURE:
      return {
        ...state,
        activeStreamInfo: {
          provider: null,
          url: null,
          isLoading: false,
          error: action.payload
        }
      };

    case  AUTHENTICATE_PERFORM_LIVE_STREAM:
      return {
        ...state,
        performInfo: {
          streamId: action.payload?.streamId,
          user: action.payload?.user,
          performAuthenticationToken: action.payload?.performAuthenticationToken,
          isHighlights: action.payload?.isHighlights,
          fixtureId: action.payload?.fixtureId,
        }
      };
    case GET_LIVE_STREAM_DATA_REQUEST:
      return {
        ...state,
        streamData: {
          data: {},
          isLoading: true,
          error: null
        }
      };
    case GET_LIVE_STREAM_DATA_SUCCESS:
      return {
        ...state,
        streamData: {
          data: action.payload,
          isLoading: false,
          error: null
        }
      };
    case GET_LIVE_STREAM_DATA_FAILURE:
      return {
        ...state,
        streamData: {
          data: {},
          isLoading: false,
          error: action.payload
        }
      };

    case GET_LIVE_STREAM_TABS_REQUEST:
      return {
        ...state,
        tabs: {
          data: [],
          isLoading: true,
          error: null
        }
      };

    case GET_LIVE_STREAM_TABS_SUCCESS:
      return {
        ...state,
        tabs: {
          data: action.payload,
          isLoading: false,
          error: null
        }
      };

    case GET_LIVE_STREAM_TABS_FAILURE: {
      return {
        ...state,
        tabs: {
          data: [],
          isLoading: false,
          error: action.payload
        }
      };
    }

    case SET_LIVE_STREAM_START:
      return {
        ...state,
        liveStreamStartTime: action.payload.liveStreamStartTime,
        matchCard: action.payload.matchCard,
        source: action.payload.source,
        hasRun: action.payload.hasRun
      };

    case SET_LIVE_STREAM_STOP:
      return {
        ...state,
        liveStreamStartTime: null,
      };

    case SET_TJK_LIVE_STREAM_START:
      return {
        ...state,
        tjkLiveStreamStartTime: action.payload.tjkLiveStreamStartTime,
      };

    case SET_TJK_LIVE_STREAM_STOP:
      return {
        ...state,
        tjkLiveStreamStartTime: null,
      };

    case GET_LIVE_STREAM_COUPONS_DATA_REQUEST:
      return {
        ...state,
        couponData: {
          ...state.couponData,
          isLoading: true,
        }
      };

    case GET_LIVE_STREAM_COUPONS_DATA_SUCCESS:
      return {
        ...state,
        couponData: {
          ...state.couponData,
          isLoading: false,
          data: action.payload,
        }
      };

    case GET_LIVE_STREAM_COUPONS_DATA_FAILURE:
      return {
        ...state,
        couponData: {
          ...state.couponData,
          isLoading: false,
          error: action.payload,
        }
      };

    case RESET_LIVE_STREAM_AUTHENTICATE:
      return {
        ...state,
        activeStreamInfo: initialState.activeStreamInfo,
        performInfo: initialState.performInfo,
      };

    default:
      return state;
  }
};
